﻿function readValue(obj: any): string | undefined {
	if (obj == null) {
		return undefined;
	}

	//toJSON covers Date (ISO string) and the wire types (DateOnly/DateTime/TimeOnly/TimeSpan);
	//String() on those would emit locale text or recurse into private fields
	if (typeof obj === "object" && typeof obj.toJSON === "function") {
		return String(obj.toJSON());
	}

	return String(obj);
}

function flattenValue(value: any, query: Record<string, string | undefined>, key: string): void {
	if (value == null) {
		query[key] = undefined;

	} else if (Array.isArray(value)) {
		value.forEach((item, i) => flattenValue(item, query, `${key}[${i}]`));

	} else if (typeof value === "object" && typeof value.toJSON !== "function") {
		flattenObjectRecursive(value, query, key);

	} else {
		query[key] = readValue(value);
	}
}

function flattenObjectRecursive(obj: any, query: Record<string, string | undefined>, prefix: string = ""): void {
	for (const key in obj) {
		if (!obj.hasOwnProperty(key)) {
			continue;
		}

		flattenValue(obj[key], query, prefix ? `${prefix}.${key}` : key);
	}
}

export default function flattenObject(obj: any, target?: Record<string, string | undefined> | undefined): Record<string, string | undefined> {
	const result = target ?? {};
	flattenObjectRecursive(obj, result);
	return result;
}
